import { useState } from "react";
import { Link } from "react-router-dom";
import { api, errMessage } from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If an account exists, a reset link will be issued.");
    } catch (err) {
      setError(errMessage(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] grid place-items-center bg-slate-50 p-6">
      <Card className="w-full max-w-md p-8 border-slate-200 shadow-sm bg-white" data-testid="forgot-page">
        <div className="text-xs uppercase tracking-[0.2em] font-bold text-slate-500 mb-2">Account recovery</div>
        <h1 className="font-heading text-2xl font-bold text-primary">Forgot your password?</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">
          We will issue a one-hour reset link if an account exists for the address you enter.
        </p>
        {sent ? (
          <>
            <div className="rounded-md border border-emerald-200 bg-emerald-50 p-4 text-sm text-emerald-800">
              If <strong>{email}</strong> exists in our records, a reset link has been generated. Check
              the credentialing office logs in development.
            </div>
            <Link to="/login" className="block text-center text-sm text-primary mt-5 hover:underline">
              Back to sign in
            </Link>
          </>
        ) : (
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label className="mb-1.5 block">Email</Label>
              <Input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            {error && <div className="text-sm text-red-600">{error}</div>}
            <Button data-testid="forgot-submit" disabled={loading} className="w-full bg-primary text-white hover:bg-[#113A64] h-11">
              {loading ? "Sending…" : "Send reset instructions"}
            </Button>
            <div className="text-center text-sm">
              <Link to="/login" className="text-primary hover:underline">Back to sign in</Link>
            </div>
          </form>
        )}
      </Card>
    </div>
  );
}
